import { orderTypeOptionsStatic } from '../../../reducer/order/constants'

export const sortPosPrices = (posPrices) => {
	return  orderTypeOptionsStatic.reduce((acc, currentOption) => {
		const foundOption = posPrices.find(posPrice => posPrice.name === currentOption.value)

		if (foundOption) {
			acc.push(foundOption)
		}

		return acc
	}, [])
}

export const parseImageUrl = (url) => {
	try {
		const parts = new URL(url).pathname.split('/')
		const menusIndex = parts.indexOf('menus')
		if (menusIndex === -1 || parts.length <= menusIndex + 2) return null

		const theme = parts[menusIndex + 1]
		const filename = parts[parts.length - 1]
		const value = filename.replace('.webp', '')

		return { theme, value }
	} catch (e) {
		return null
	}
}
